/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NameStampAnswerValue } from '../models/NameStampAnswerValue';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class NameStampAnswerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Sumit a user's name stamp for a question in a form response.
     * @param responseGuid The response's guid.
     * @param formElementGuid The form element's guid.
     * @returns NameStampAnswerValue OK
     * @throws ApiError
     */
    public addStamp(
        responseGuid: string,
        formElementGuid: string,
    ): CancelablePromise<Array<NameStampAnswerValue>> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/responses/{responseGuid}/namestamp/{formElementGuid}/AddStamp',
            path: {
                'responseGuid': responseGuid,
                'formElementGuid': formElementGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete a name stamp by its id.
     * @param responseGuid The response's guid.
     * @param formElementGuid The form element's guid.
     * @param stampGuid The guid of the stamp to remove.
     * @returns NameStampAnswerValue OK
     * @throws ApiError
     */
    public removeStamp(
        responseGuid: string,
        formElementGuid: string,
        stampGuid: string,
    ): CancelablePromise<Array<NameStampAnswerValue>> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/responses/{responseGuid}/namestamp/{formElementGuid}/{stampGuid}/RemoveStamp',
            path: {
                'responseGuid': responseGuid,
                'formElementGuid': formElementGuid,
                'stampGuid': stampGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
